import { redirectToLogin } from "../annoucement-sheet";
import { api } from "../api";
import authHeader from "../auth-header";
export interface IServicePageInfoData {
    "page": IServiceDataInfo,
    "page_service_section":any;
}
export interface IServiceDataInfo {
    "id": number,
    "sub_menu_id": number,
    "menu_id": number,
    "slug": string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "meta_title_en": string,
    "meta_title_tc": string,
    "meta_title_sc": string,
    "meta_description_en": string,
    "meta_description_tc": string,
    "meta_description_sc": string,
    "meta_image": string,
    "banner_mobile_image": string,
    "banner_desktop_image": string,
}

export type TData = {
    data: [];
    total: number;
};
export type PaginationData = {
    page: number;
    limit: number | string | undefined;
    search: string | number;
    sort?: string;
    type?: string;
};
export const jobApplicationApi = api.injectEndpoints({
    endpoints: (build) => ({
        getApplicationPage: build.query<IServicePageInfoData, string>({
            query: (page_type) => ({
                url: `fetch-join-sats-page?page_type=${page_type}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "Job" as const, id: "LIST" }]
        }),
        fetch_application: build.query<TData, PaginationData>({
            query: ({ limit, page, search,type,sort }) => ({
                url: `fetch-job-applications?per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "JobApplication" as const, id: "LIST" }]
        }),
        fetch_application_info: build.mutation<TData, PaginationData>({
            query({ limit, page, search, type,sort }) {
                return {
                    headers: authHeader(),
                    url: `fetch-job-applications?per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
                    method: "GET",
                };
            },
            invalidatesTags: ['JobApplication']
        }),
        fetch_application_detail: build.mutation<TData, number>({
            query(id) {
                return {
                    headers: authHeader(),
                    url: `fetch-job-applications/${id}`,
                    method: "GET",
                };
            },
            invalidatesTags: ['JobApplication']
        }),
        deleteApplication: build.mutation<TData, number>({
            query(body) {
                return {
                    headers: authHeader(),
                    url: `delete-job-applications`,
                    body: {
                        id: body
                    },
                    method: "POST",
                };
            },
            invalidatesTags: ['JobApplication']
        }),
    })
});

export const { useGetApplicationPageQuery,useFetch_applicationQuery,useFetch_application_infoMutation,useDeleteApplicationMutation,useFetch_application_detailMutation } = jobApplicationApi;

export const {
    endpoints: { getApplicationPage,fetch_application,fetch_application_info,deleteApplication,fetch_application_detail }
} = jobApplicationApi;
